import { getAmplitudeInstance } from '../amplitudeHelpers';
import VisitationHour from '../enums/VisitationHour';

type logTrailDetailsVisitationHourSelectedParams = {
  trail_id: number;
  visitation_hour_selected: VisitationHour;
};

/**
 * User select or hover over an hour in Visitation module.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 * @param params.visitation_hour_selected - Hour selected or hovered over by user in Visitation module.
 */
const logTrailDetailsVisitationHourSelected = (
  { trail_id, visitation_hour_selected }: logTrailDetailsVisitationHourSelectedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details visitation hour selected',
    { 'trail id': trail_id, 'visitation hour selected': visitation_hour_selected },
    callback
  );
};

export default logTrailDetailsVisitationHourSelected;
